// History Selectors
export const getBlocksData = (state) => state.data.history.blocks;
